import styled from "@emotion/styled/macro";
import { Buttons } from "../../common/TwoButtonModal/TwoButtonModal.styles";
import rem from "../../utils/rem/rem";




export const DeleteButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: ${rem(28)};
    width: ${rem(44)};
    height: ${rem(44)};
    color: ${({ theme }) => theme.colors.gray600};
    &:focus {
      outline: none;
    }
    &:focus svg {
      ${({ theme }) => theme.states.focus};
    }
`;

export const StyledButtons = styled(Buttons)`
  margin-top: ${rem(32)};
`;

export const ReadOnlyInputs = styled.div`
display: flex;
flex-direction: row;
flex-wrap: wrap;
gap: 24px;
padding-bottom: ${rem(32)};

div {
  width: ${rem(300)};
}
`;